/**
 * @generated SignedSource<<d26ecded47bb47d3a5f978ddf877c004>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GetStudentLearnositySessionInput = {
  skillId: string;
};
export type SkillResourceGetAssessmentStatusMutation$variables = {
  input: GetStudentLearnositySessionInput;
};
export type SkillResourceGetAssessmentStatusMutation$data = {
  readonly getStudentLearnositySession: {
    readonly incompleteLearnositySessionNode: {
      readonly activityId: string | null | undefined;
      readonly id: string;
      readonly sessionId: any;
      readonly status: string | null | undefined;
    } | null | undefined;
  };
};
export type SkillResourceGetAssessmentStatusMutation = {
  response: SkillResourceGetAssessmentStatusMutation$data;
  variables: SkillResourceGetAssessmentStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GetStudentLearnositySessionPayload",
    "kind": "LinkedField",
    "name": "getStudentLearnositySession",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "IncompleteLearnositySessionNode",
        "kind": "LinkedField",
        "name": "incompleteLearnositySessionNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activityId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SkillResourceGetAssessmentStatusMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SkillResourceGetAssessmentStatusMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "85d36f6d52679e22949dae50865523ad",
    "id": null,
    "metadata": {},
    "name": "SkillResourceGetAssessmentStatusMutation",
    "operationKind": "mutation",
    "text": "mutation SkillResourceGetAssessmentStatusMutation(\n  $input: GetStudentLearnositySessionInput!\n) {\n  getStudentLearnositySession(input: $input) {\n    incompleteLearnositySessionNode {\n      id\n      activityId\n      sessionId\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e67f5a9b4bae11712d24921859372cbf";

export default node;
